<template>
    <ob1-expanding-accordion
        class="bg-greige px-1"
        with-icon
        :icon-name="'icon-rewards'"
        :link-title="advantagesLabel"
        :link-id="'refunds-button'"
        :collapsed-block-id="'refunds-detail'"
    >
        <ul class="list-unstyled ms-1 mb-0">
            <template
                v-if="recovery"
            >
                <li class="row mb-1">
                    <span class="col-12 col-md-8 ps-0">
                        <ob1-liens
                            v-if="recovery.recyclingUrl"
                            class="p-0 text-start"
                            is-link
                            :href="recovery.recyclingUrl"
                            :text="recovery.label"
                            data-oevent-label="recycler_votre_ancien_mobile"
                            :data-oevent-action="'0€_sur_votre_'+recoveryDeviceNameForTms"
                            data-oevent-category="reprise_mobile_avec_recyclage"
                            target="_blank"
                        />
                        <ob1-liens
                            v-else
                            class="p-0 text-start"
                            is-button
                            :modal-id="'mobile-recovery-simulator'"
                            data-bs-toggle="modal"
                            :text="recovery.label"
                            data-oevent-label="estimer_votre_mobile_actuel"
                            :data-oevent-action="recovery.amountInCents == null ?'selon_l_etat_de_votre_mobile_actuel' : recovery.amountInCents/100 + '€_sur_votre_'+recoveryDeviceNameForTms"
                            :data-oevent-category="recovery.amountInCents == null ? 'reprise_mobile_sans_consentement' : 'reprise_mobile_avec_consentement'"
                        />
                    </span>
                    <span class="col-12 col-md-4 ps-0 fw-bold amount">
                        <span>
                            {{ recovery.details }}
                        </span>
                    </span>
                    <mobile-recovery-simulator-modal
                        v-if="recovery.simulatorUrl"
                        modal-id="mobile-recovery-simulator"
                        :title="refundMessages.recoverySimulator.title"
                        :subtitle="refundMessages.recoverySimulator.subtitle"
                        :url="recovery.simulatorUrl"
                    />
                </li>
                <li
                    v-if="recovery.bonus"
                    class="row mb-1"
                >
                    <span class="col-12 col-md-8 ps-0">
                        <ob1-liens
                            class="p-0 text-start"
                            is-button
                            :modal-id="'mobile-recovery-popin'"
                            data-bs-toggle="modal"
                            :text="refundMessages.bonusTitle"
                            :data-oevent-label="'vers_popin_bonus_reprise'"
                            :data-oevent-category="'bonus_reprise_fiche_produit'"
                            :data-oevent-action="recovery.bonus.amountInCents/100 + '€_sur_votre_nouveau_mobile'"
                        />
                    </span>
                    <span class="col-12 col-md-4 ps-0 fw-bold amount">
                        <span>{{ bonusAmountFormat }}</span>
                    </span>
                </li>
                <mobile-recovery-details-modal
                    :modal-id="'mobile-recovery-popin'"
                    :infos-recovery="refundMessages.recoveryModal.infosRecovery"
                    :online-recovery="onlineRecovery ? refundMessages.recoveryModal.onlineRecovery: null"
                    :store-recovery="storeRecovery ? refundMessages.recoveryModal.storeRecovery : null"
                    :bonus-recovery="recovery.bonus ? refundMessages.recoveryModal.bonusRecovery : null"
                    :bonus="recovery.bonus"
                    :recovery-simulator="refundMessages.recoverySimulator"
                    :simulator-button-label="refundMessages.simulatorButtonLabel"
                    :recovery-value="recovery"
                    :bonus-amount="bonusAmountFormat"
                />
            </template>
            <li v-for="(odr, index) in odrs" :key="index" class="row mb-1">
                <odr
                    class="ps-0"
                    :modal-id="'popin-odr-' + deviceSeoId + '-' + index"
                    :odr-name="odr.name"
                    :odr-amount-in-cents="odr.amountInCents"
                    :odr-start-date="odr.dates.start"
                    :odr-end-date="odr.dates.end"
                    :odr-link="odr.link"
                    :promo-odr-messages="refundMessages.odrMessages"
                />
            </li>
            <li v-if="!isWithoutAdvantage" class="row">
                <strong class="ps-0" v-html="refundMessages.withConditionsLabel" />
            </li>
        </ul>
    </ob1-expanding-accordion>
</template>

<script>

import Odr from "./Odr.vue";
import MobileRecoveryDetailsModal from "../MobileRecoveryDetailsModal.vue";
import MobileRecoverySimulatorModal from "../MobileRecoverySimulatorModal.vue";
import {toTmsFormat} from "../../../common/utils/TmsUtils";

export default {
    components: {MobileRecoverySimulatorModal, MobileRecoveryDetailsModal, Odr},
    props: {
        deviceSeoId: {
            type: String,
            required: true
        },
        refundMessages: {
            type: Object,
            required: true
        },
        odrs: {
            type: Array,
            default() {
                return []
            }
        },
        onlineRecovery: {
            type: Boolean,
            default: false
        },
        storeRecovery: {
            type: Boolean,
            default: false
        },
        recovery: {
            type: Object,
            default: null
        },
        totalAmountInCents: {
            type: Number,
            required: true
        },
        advantagesLabel: {
            type: String,
            required: true
        }
    },
    computed: {
        isWithoutAdvantage() {
            return this.totalAmountInCents === 0
        },
        bonusAmountFormat() {
            if (this.recovery && this.recovery.bonus) {
                return PriceFormatter.formatEurosWithSpace(this.recovery.bonus.amountInCents / 100, false).toString()
            } else return null
        },
        recoveryDeviceNameForTms(){
            if (this.recovery) {
                return toTmsFormat(this.recovery.deviceModel)
            } else return null
        }

    },
}
</script>

<style scoped lang="scss">

@media (min-width: 736px) {
    .amount {
        display: flex;
        justify-content: flex-end;
    }
}

</style>
